// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import Vue from 'vue'
import TurbolinksAdapter from 'vue-turbolinks'
import VueDataScooper from 'vue-data-scooper'
import "../src/design/common"
import jQuery from 'jquery'

Rails.start()
Turbolinks.start()
ActiveStorage.start()

const images = require.context('../images/', true)
const imagePath = (name) => images(name);

Vue.use(TurbolinksAdapter)
Vue.use(VueDataScooper)

document.addEventListener('turbolinks:load', () => {
  const el = document.querySelectorAll('[data-vue]')
  if(el.length > 0){
    for(let i = 0; i < el.length; i++){
      import('../src/pages/' + el[i].dataset.vue)
      .then(module => {
        let attributes = JSON.parse(el[i].dataset.attributes || '{}')
        const vueapp = new Vue(module.default(attributes))
      })
    }
  }
})
